module.exports = __webpack_public_path__ + "img/premium_gold_crown.7ba01d14.svg";